<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="dialogForm" class="label-gray" label-width="100px" :rules="rules" ref="dialogForm">
      <template v-if="!dialogData.row">
        <el-form-item label="固件文件" prop="file">
          <upload-file v-model="dialogForm.file" @change="fileChange" suffix="trx|bin"/>
        </el-form-item>
        <el-form-item label="设备型号" prop="model">
          <el-input v-model.trim="dialogForm.model" clearable></el-input>
        </el-form-item>
        <el-form-item label="固件版本" prop="sversion">
          <el-input v-model.trim="dialogForm.sversion" clearable></el-input>
        </el-form-item>
      </template>
      <el-form-item label="备注">
        <el-input v-model.trim="dialogForm.remark" clearable></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty, changeEmpty} from '@utils/validate'
  import {getMsgInstance} from '@utils/element'
  import UploadFile from "@view/components/upload/UploadFile"
  export default {
    name: "FirmwareOperate",
    props: {dialogData: Object},
    components: {UploadFile},
    data() {
      let checkExist = async (rule, value, callback) => {
        let res = await this.$Http.checkFirmware({model: value});
        if (res) {
          callback();
        } else {
          let msgInstance = getMsgInstance();
          msgInstance?.close();
          let msg = msgInstance?.$el?.innerText;
          callback(new Error(msg));
        }
      };
      return {
        dialogForm: {
          file: null,
          model: "",
          sversion: "",
          remark: ""
        },
        rules: {
          file: [changeEmpty("固件文件")],
          model: [inputEmpty("设备型号"),{validator: checkExist, trigger: 'blur'}],
          sversion: [inputEmpty("固件版本")]
        }
      }
    },
    created() {
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.dialogForm).forEach(key => this.dialogForm[key] = this.showData(key, row, ""));
        delete this.dialogForm.file;
        delete this.dialogForm.model;
        delete this.dialogForm.sversion;
      }
    },
    methods: {
      fileChange(file) {
        let fileNameArr = file?.name?.split("-") || [];
        this.dialogForm.model = fileNameArr[0] || "";
        let version_tmp = fileNameArr[1] || "";
        this.dialogForm.sversion = version_tmp.slice(0, version_tmp.lastIndexOf("."));
      },
      confirm() {
        let row = this.dialogData.row;
        row ? this.revise(row) : this.add();
      },
      add() {
        this.$refs["dialogForm"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.dialogForm};
            let res = await this.$Http.addFirmware(nv, {timeout: 2*60*1000}, true);
            if (res) {
              this.msgSuccess("上传成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
      revise(row) {
        let nv = {};
        for(let [key, val] of Object.entries(this.dialogForm)) {
          if (val !== this.showData(key, row, "")) {
            nv[key] = val;
          }
        }
        if (Object.keys(nv).length) {
          this.$refs["dialogForm"].validate(isOk => {
            if (isOk) {
              this.openConfirm("修改该固件", async () => {
                nv.optionId = row.id;
                let res = await this.$Http.reviseFirmware(nv);
                if (res) {
                  this.msgSuccess("修改成功");
                  this.$emit("table-reload");
                  this.dialogData.visible = false;
                }
              });
            }
          });
        } else {
          this.msgInfo("您尚未做任何修改")
        }
      },
    }
  }
</script>

<style scoped>

</style>
